module.exports = __webpack_public_path__ + "img/hetong.a3cc4efc.png";